"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpacerDocumentElement = void 0;
const react_1 = __importDefault(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const type = "Spacer";
//const divWidth = document.getElementById("document")?.offsetWidth ?? 100;
exports.SpacerDocumentElement = {
    type,
    sideBarComponent: () => react_1.default.createElement("div", null, " "),
    documentComponent: () => react_1.default.createElement("div", { className: "w-full block", style: { minHeight: "20px", height: "20px" } }),
    propertiesComponent: () => react_1.default.createElement("div", null, "Properties Components"),
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            extra_attributes: {
                edit_type: "block",
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faEmptySet,
        label: "Spacer",
    },
};
